// extracted by mini-css-extract-plugin
export var label = "_d8-1";
export var reminder = "_d8-0";